export default "__VITE_ASSET__d9931893__"